import styled from "styled-components"

import Link from "~/components/atoms/Link"
import Pc from "~/components/atoms/Pc"
import Sp from "~/components/atoms/Sp"
import Tab from "~/components/molecules/Tab"
import User from "~/components/organisms/User"
import { Color } from "~/consts/style-mixins"
import { Company } from "~/entities/Company"
import { internalLink } from "~/services/helper"

interface Props {
  company: Company
  selectedTabIndex: number
}

const DetailMenu = ({ company, selectedTabIndex }: Props) => {
  return (
    <>
      <StyledSpTabWrapper>
        <Tab
          items={[
            {
              name: "会社",
              href: internalLink("/companies/[company-id]"),
              dynamicRoutePath: internalLink(`/companies/${company.id}`),
            },
            {
              name: "募集",
              href: internalLink("/companies/[company-id]/recruitments"),
              dynamicRoutePath: internalLink(`/companies/${company.id}/recruitments`),
            },
          ]}
          size="Medium"
          full={true}
          selectedTabIndex={selectedTabIndex}
        />
      </StyledSpTabWrapper>
      <StyledPcTabWrapper>
        <LinkWrapper>
          <Link
            href={internalLink("/companies/[company-id]")}
            dynamicRoutePath={internalLink(`/companies/${company.id}`)}
          >
            <User type="Medium" iconPath={company.logoImgUrl} name={company.name} description={company.overview} />
          </Link>
        </LinkWrapper>
        <Tab
          items={[
            {
              name: "会社",
              href: internalLink("/companies/[company-id]"),
              dynamicRoutePath: internalLink(`/companies/${company.id}`),
            },
            {
              name: "募集",
              href: internalLink("/companies/[company-id]/recruitments"),
              dynamicRoutePath: internalLink(`/companies/${company.id}/recruitments`),
            },
          ]}
          size="Medium"
          selectedTabIndex={selectedTabIndex}
          vertical={true}
        />
      </StyledPcTabWrapper>
    </>
  )
}

const StyledSpTabWrapper = styled(Sp)`
  width: 100vw;
  position: relative;
  left: 50%;
  right: 50%;
  margin-left: -50vw;
  margin-right: -50vw;
`

const StyledPcTabWrapper = styled(Pc)`
  width: 280px;
`

const LinkWrapper = styled.div`
  margin-bottom: 16px;
  padding-bottom: 16px;
  border-bottom: 1px solid ${Color.BorderGray};
`

export default DetailMenu
